import { PersistWebData } from '../persist/persistwebdata';
import { UserContext, UserContextImpl } from './usercontext';
import { ConfigurationSettings, ConfigurationSettingsImpl } from '../configurationsettings/configurationsettings';
import { AESEncryptionDecryption } from '../aseencryption';
import { DataCache } from './datacacheenum';
import { WebSessionStorage } from '../persist/websessionstorage';

export class UserDataCache
{
     private persisData: PersistWebData;
     private userContext: UserContext;
     private configurationSettings: ConfigurationSettings;

     constructor()
     {
         this.persisData = new WebSessionStorage();
         this.userContext = new UserContextImpl();
         this.configurationSettings = new ConfigurationSettingsImpl();

         let userData = this.persisData.getItem(DataCache.USER_DATA);
         let configurationSettingsData = this.persisData.getItem(DataCache.CONFIGURATION_SETTINGS);

         if(userData !== null)
         {
            let decryptedData = AESEncryptionDecryption.decryptWithAES(userData, DataCache.USER_DATA_KEY);
             (this.userContext as UserContextImpl).fromJson(JSON.parse(decryptedData));
         }

         if(configurationSettingsData !== null && configurationSettingsData !== "undefined")
         {
            this.configurationSettings.updateLanguage(this.userContext.getLanguage());
            let configurationDecryptedData = AESEncryptionDecryption.decryptWithAES(configurationSettingsData,
                DataCache.CONFIGURATION_SETTINGS_KEY);
            this.configurationSettings.setConfigurationSettings(JSON.parse(configurationDecryptedData));
         }
     }

     updateUserContext(userContext: UserContext)
     {
         this.userContext = userContext;

         this.configurationSettings.updateLanguage(userContext.getLanguage());
         this.persisData.setItem(DataCache.USER_DATA, AESEncryptionDecryption.encryptWithAES(
             JSON.stringify(userContext), DataCache.USER_DATA_KEY));
     }

     updateConfigurationSettings(configurationSettingsMap: any)
     {
         this.configurationSettings.updateLanguage(this.userContext.getLanguage());
         this.configurationSettings.setConfigurationSettings(configurationSettingsMap);

         this.persisData.setItem(DataCache.CONFIGURATION_SETTINGS, 
            AESEncryptionDecryption.encryptWithAES(JSON.stringify(configurationSettingsMap), 
            DataCache.CONFIGURATION_SETTINGS_KEY));
     }

     getUserContext(): UserContext
     {
         return this.userContext;
     }

     getConfgiurationSettings(): ConfigurationSettings
     {
         return this.configurationSettings;
     }

    clearCache()
    {
        this.persisData.setItem(DataCache.USER_DATA, 
            AESEncryptionDecryption.encryptWithAES(JSON.stringify(new UserContextImpl()),
            DataCache.USER_DATA_KEY));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/usercontext/userdatacache.ts